import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/components/NotFound'
import Index from '@/views/Index'
import UCIndex from '@/views/usercenter/Index'
import VideoPlayer from '@/views/VideoPlayer'
import Handout from '@/views/Handout'
import CertificateQuery from '@/views/CertificateQuery'
import Help from '@/views/Help'
import About from '@/views/About'
import NewsInfo from '@/views/NewsInfo'
import NewsList from '@/views/NewsList'
import NewsMore from '@/views/NewsMore'
import ContinuingMedicalEducation from '@/views/ContinuingMedicalEducation'
import PerfectCourseList from '@/views/PerfectCourseList'
import MedicalDynamicNewsList from '@/views/MedicalDynamicNewsList'
import ProjectDtail from '@/views/usercenter/ProjectDetail'
import CenterRoot from '@/views/usercenter/CenterRoot'
import MyPractise from '@/views/usercenter/MyPractise'
import MyExam from '@/views/usercenter/MyExam'
import MyScore from '@/views/usercenter/MyScore'
import MyTraining from '@/views/usercenter/MyTraining'
import MyCard from '@/views/usercenter/MyCard'
import EditUser from '@/views/usercenter/EditUser'
import Register from '@/views/Register'
import PracticeAfterCourse from '@/views/usercenter/PracticeAfterCourse'
import Contract from '@/views/Contract'
import SecondSubject from '@/views/SecondSubject'
import MedicalSearch from '@/views/MedicalSearch'
import FindByMobile from '@/views/FindByMobile'
import FindByEmail from '@/views/FindByEmail'
import FindByWX from '@/views/FindByWX'
import findByShortMsg from '../views/FindByShortMsg.vue'
import ExamInfo from '@/views/ExamInfo'
import PaySuccess from '@/views/PaySuccess'
import LearningActivities from '@/views/LearningActivities'
import MedicalAccidentIdentification from '@/views/MedicalAccidentIdentification'
import RegularExamination from '@/views/RegularExamination'
import HotNews from '@/views/HotNews'
import DownLoad from '@/views/DownLoad'
import QueryCredit from '@/views/QueryCredit'
import DangfengDangjian from '@/views/DangfengDangjian'
import Jxjytzgg from '@/views/Jxjy-tzgg'
import Jxjygzdt from '@/views/Jxjy-gzdt'
import Jxjyzcfg from '@/views/Jxjy-zcfg'

import Xhhdtzgg from '@/views/Xhhd-tzgg'
import Xhhdxhgl from '@/views/Xhhd-xhgl'
import Xhhdyjxh from '@/views/Xhhd-yjxh'
import Xhhdejxh from '@/views/Xhhd-ejxh'

import Ylsgjdtzgg from '@/views/Ylsgjd-tzgg'
import Ylsgjdzcfg from '@/views/Ylsgjd-zcfg'
import Ylsgjdxgwj from '@/views/Ylsgjd-xgwj'
import Ylsgjdgzdt from '@/views/Ylsgjd-gzdt'
import Ylsgjdbszn from '@/views/Ylsgjd-bszn'

import Ysdqkhtzgg from '@/views/Ysdqkh-tzgg'
import Ysdqkhzcfg from '@/views/Ysdqkh-zcfg'
import Ysdqkhgzdt from '@/views/Ysdqkh-gzdt'
import nCoV2019Knowledge from '@/views/nCoV-2019-Knowledge'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/findByMobile',
      name: 'FindByMobile',
      component: FindByMobile,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/findByEmail',
      name: 'FindByEmail',
      component: FindByEmail,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/findByWX',
      name: 'FindByWX',
      component: FindByWX,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/findByShortMsg',
      name: 'findByShortMsg',
      component: findByShortMsg,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/contract',
      component: Contract,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/usercenter/projectDtail',
      name: 'ProjectDtail',
      component: ProjectDtail,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/secondSubject',
      name: 'SecondSubject',
      component: SecondSubject,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/usercenter/practice',
      name: 'practice',
      component: PracticeAfterCourse,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/videoPlayer',
      name: 'VideoPlayer',
      component: VideoPlayer,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/examInfo',
      name: 'ExamInfo',
      component: ExamInfo,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/handout',
      name: 'handout',
      component: Handout,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/certificateQuery',
      name: 'certificateQuery',
      component: CertificateQuery,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/help',
      name: 'help',
      component: Help,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/newsInfo',
      name: 'newsInfo',
      component: NewsInfo,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: NewsList,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/newsMore',
      name: 'newsMore',
      component: NewsMore,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/medicalSearch',
      name: 'MedicalSearch',
      component: MedicalSearch,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/perfectCourseList',
      name: 'perfectCourseList',
      component: PerfectCourseList,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/medicalDynamicNewsList',
      name: 'medicalDynamicNewsList',
      component: MedicalDynamicNewsList,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: PaySuccess,
      meta: {title: '十堰市卫生界学会网'}
    },
    {
      path: '/continuingMedicalEducation',
      name: 'ContinuingMedicalEducation',
      component: ContinuingMedicalEducation,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/learningActivities',
      name: 'LearningActivities',
      component: LearningActivities,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/medicalAccidentIdentification',
      name: 'MedicalAccidentIdentification',
      component: MedicalAccidentIdentification,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/dangfengdangjian',
      name: 'DangfengDangjian',
      component: DangfengDangjian,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/regularExamination',
      name: 'RegularExamination',
      component: RegularExamination,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/hotNews',
      name: 'HotNews',
      component: HotNews,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/downLoad',
      name: 'DownLoad',
      component: DownLoad,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/queryCredit',
      name: 'QueryCredit',
      component: QueryCredit,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/jxjytzgg',
      name: 'Jxjytzgg',
      component: Jxjytzgg,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/jxjygzdt',
      name: 'Jxjygzdt',
      component: Jxjygzdt,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/jxjyzcfg',
      name: 'Jxjyzcfg',
      component: Jxjyzcfg,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/xhhdtzgg',
      name: 'Xhhdtzgg',
      component: Xhhdtzgg,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/xhhdxhgl',
      name: 'Xhhdxhgl',
      component: Xhhdxhgl,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/xhhdyjxh',
      name: 'Xhhdyjxh',
      component: Xhhdyjxh,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/xhhdejxh',
      name: 'Xhhdejxh',
      component: Xhhdejxh,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/ylsgjdtzgg',
      name: 'Ylsgjdtzgg',
      component: Ylsgjdtzgg,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/ylsgjdzcfg',
      name: 'Ylsgjdzcfg',
      component: Ylsgjdzcfg,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/ylsgjdxgwj',
      name: 'Ylsgjdxgwj',
      component: Ylsgjdxgwj,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/ylsgjdgzdt',
      name: 'Ylsgjdgzdt',
      component: Ylsgjdgzdt,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/ylsgjdbszn',
      name: 'Ylsgjdbszn',
      component: Ylsgjdbszn,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/ysdqkhtzgg',
      name: 'Ysdqkhtzgg',
      component: Ysdqkhtzgg,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/ysdqkhzcfg',
      name: 'Ysdqkhzcfg',
      component: Ysdqkhzcfg,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/ysdqkhgzdt',
      name: 'Ysdqkhgzdt',
      component: Ysdqkhgzdt,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/nCoV2019Knowledge',
      name: 'nCoV2019Knowledge',
      component: nCoV2019Knowledge,
      meta: {title: '十堰市卫生界学会网', scrollToTop: true}
    },
    {
      path: '/usercenter',
      redirect: '/usercenter/index',
      component: CenterRoot,
      meta: {scrollToTop: true},
      children: [
        {
          path: '/usercenter/index',
          component: UCIndex,
          meta: {title: '十堰市卫生界学会网'}
        },
        {
          path: '/MyPractise',
          component: MyPractise,
          meta: {title: '十堰市卫生界学会网'}
        },
        {
          path: '/MyExam',
          component: MyExam,
          meta: {title: '十堰市卫生界学会网'}
        },
        {
          path: '/MyScore',
          component: MyScore,
          meta: {title: '十堰市卫生界学会网'}
        },
        {
          path: '/MyTraining',
          component: MyTraining,
          meta: {title: '十堰市卫生界学会网'}
        },
        {
          path: '/MyCard',
          component: MyCard,
          meta: {title: '十堰市卫生界学会网'}
        },
        {
          path: '/EditUser',
          component: EditUser,
          meta: {title: '十堰市卫生界学会网'}
        }
      ]
    },
    {
      path: '/Page/MainPage.aspx',
      redirect: {name: 'Index'}
    },
    {path: '*', component: NotFound}
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition
    } else {
      const position = {}
      // new navigation.
      // scroll to anchor by returning the selector
      if (to.hash) {
        position.selector = to.hash
      }
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some(m => m.meta.scrollToTop)) {
        // cords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0
        position.y = 0
      }
      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return position
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js